export default "__VITE_PUBLIC_ASSET__0901f1fa__"